// Ports that are one place to a customer. The feed has no rates under the generic Shenzhen code (CNSZX): the boxes
// leave from Yantian (CNYTN), so Shenzhen IS Yantian (owner, 2026-10-02: "same rate always"). Asking for either
// returns the same answer, because asking for CNSZX is answered as CNYTN. The database does the same
// (migration 025: frm_canonical_port), so no reader can get a different Shenzhen from a different door.
//
// Shared by the REST routes, the web board and (through the API) the MCP server: one table, one meaning.

export const PORT_ALIASES: Readonly<Record<string, { to: string; name: string }>> = {
  CNSZX: { to: 'CNYTN', name: 'Shenzhen (Yantian)' },
}

/** The port a code is served as: an alias source maps to its target, anything else is itself. Case-insensitive. */
export function canonicalPort(code: string): string {
  const k = code.trim().toUpperCase()
  return PORT_ALIASES[k]?.to ?? k
}

/** What changed, for a response that must say it: the requested code and the code it was served as. */
export function aliasNote(code: string): { requested: string; served_as: string } | null {
  const k = code.trim().toUpperCase()
  const to = PORT_ALIASES[k]?.to
  return to ? { requested: k, served_as: to } : null
}
